export const PROCESS_MATCHING_CRITERIA_MAX_STEPS_DEFAULT = 15
export const PROCESS_MATCHING_CRITERIA_MAX_TIME_SEC_DEFAULT = 120

export const PROCESS_CONFIG_TABS = [
  { label: 'Basic configurations', value: 'basic' },
  { label: 'Advanced configurations', value: 'advanced' },
]

export const PROCESS_FORM_TIP_BOX = 'rounded-md border border-gray-200 bg-gray-50 p-3.5'
